import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-modal-shell',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './modal-shell.component.html',
})
export class ModalShellComponent {
  @Input() title: string;
  @Input() cancelLabel = 'COMMON.CANCEL';
  @Input() saveLabel = 'COMMON.OK';
  @Output() cancelClicked = new EventEmitter<void>();
  @Output() saveClicked = new EventEmitter<void>();
}

